export default class BlockUI {
  static blockWithId(elemId, msg) {
    const $elem = $(`#${elemId}`);
    BlockUI.blockElem($elem, msg);
  }

  static unblockWithId(elemId) {
    const $elem = $(`#${elemId}`);
    BlockUI.unblockElem($elem);
  }

  static blockElem(elem, msg) {
    const $elem = elem instanceof jQuery ? elem : $(elem);
    $elem.block(BlockUI.defaultOptions(msg));
  }

  static unblockElem(elem) {
    const $elem = elem instanceof jQuery ? elem : $(elem);
    $elem.unblock();
  }

  static blockPage(msg) {
    $.blockUI(BlockUI.defaultOptions(msg));
  }

  static unblockPage() {
    $.unblockUI();
  }

  static defaultOptions(msg = "Loading...") {
    return {
      message: `<i class="fa fa-gear fa-spin fa-2x"></i><span class="block-ui">&nbsp;${msg}</span>`,
      overlayCSS: {
        backgroundColor: "var(--bs-light)",
        opacity: 0.6,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    };
  }
}
